$("document").ready(function () {
	if ($("#popup__news").length) {

		var modalOptions = {
			callbacks: {
				afterClose: function () {
					createCookie('banner_popup__news', true, 360);
				}
			},
			anim: {
				showBg: 'transfer',
				showCont: 'transfer',
				hideCont: 'transfer'
			}
		}

		var showbanner = readCookie('banner_popup__news');

		$(".top-linka-zavolat a.button").nyroModal(modalOptions);

		if (!showbanner) {
			$.nmManual("#popup__news", modalOptions);
		}
	}
});